import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import ProfileSettings from '@Services/ProfileSettings';
import { ProfileSettingsConfig } from '@Constants/rx-user/constants';

import TextColor from './Components/TextColor';
import TextContrast from './Components/TextContrast';
import TextSize from './Components/TextSize';
import BlockHeading from '../../BlockHeading';
import PreferencesSectionItem from '../../PreferencesSectionItem';

const getPageStyleOptions = (property) => {
  const combinedInfo = ProfileSettings.getCombinedInfo();
  return ProfileSettings.getModelValue(combinedInfo, `PAGE_STYLE.${property}`).values;
};

function PreferencesTextAndContrastSection({ editUser, onChange, onSave, onClose }) {
  return (
    <div>
      <BlockHeading title={ProfileSettingsConfig.Labels.textAndContrast} />
      <PreferencesSectionItem
        name="RX2_PAGE_STYLE_TEXT_SIZE_RELATIVE"
        prefix="PAGE_STYLE"
        currentOption={editUser.PAGE_STYLE.RX2_PAGE_STYLE_TEXT_SIZE_RELATIVE}
        options={getPageStyleOptions('RX2_PAGE_STYLE_TEXT_SIZE_RELATIVE')}
        onChange={onChange}
        onClose={onClose}
        onSave={onSave}>
        <TextSize />
      </PreferencesSectionItem>

      <PreferencesSectionItem
        name="RX2_PAGE_STYLE_TEXT_CONTRAST"
        prefix="PAGE_STYLE"
        currentOption={editUser.PAGE_STYLE.RX2_PAGE_STYLE_TEXT_CONTRAST}
        options={getPageStyleOptions('RX2_PAGE_STYLE_TEXT_CONTRAST')}
        onChange={onChange}
        onClose={onClose}
        onSave={onSave}>
        <TextContrast />
      </PreferencesSectionItem>

      <PreferencesSectionItem
        name="RX2_PAGE_STYLE_TEXT_COLOR"
        prefix="PAGE_STYLE"
        currentOption={editUser.PAGE_STYLE.RX2_PAGE_STYLE_TEXT_COLOR}
        options={getPageStyleOptions('RX2_PAGE_STYLE_TEXT_COLOR')}
        onChange={onChange}
        onClose={onClose}
        onSave={onSave}>
        <TextColor />
      </PreferencesSectionItem>
    </div>
  );
}

PreferencesTextAndContrastSection.propTypes = {
  editUser: PropTypes.object,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

PreferencesTextAndContrastSection.defaultProps = {
  onChange: noop,
  onSave: noop,
  onClose: noop,
};

export default PreferencesTextAndContrastSection;
